// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"bc2dffbe","198":"629506b5","404":"2fd1372e","591":"5d9eb8df"}[chunkId] + ".chunk.js";
};